export default __webpack_public_path__ + "static/media/about-icon4.9de0d6d7.svg";